export default __webpack_public_path__ + "static/santander-banner-1024-6bfc8e42bf42f987d501392969afd99e.png";